export enum DenialReason {
  MEDICAL_NECESSITY = "Not medically necessary",
  FORMULARY = "Not covered on formulary",
  SITE_OF_CARE = "Not covered at site of care",
  NETWORK = "Doctor not in network",
  PLAN_EXCLUSION = "Excluded plan benefit",
  STEP_THERAPY_REQUIRED = "Requires step therapy",
  FORCED_MEDICATION_SWITCH = "Forced switch by plan",
  QUANTITY_LIMITS_EXCEEDED = "Quantity limits exceeded",
  TIER_EXCEPTION = "Tier exception",
  EXPERIMENTAL_OR_INVESTIGATIONAL = "Experimental or investigational",
  PA_REQUIREMENTS_NOT_MET = "PA requirements not met",
  ANTICIPATED_FORMULARY_CHANGE = "Anticipated formulary change",
}

export enum DenialUpheldReason {
  NOT_SURE = "Not Sure",
  MISSING_INFORMATION = "Missing Information",
  CODING_ERRORS = "Coding Errors",
  DUPLICATE_CLAIMS = "Duplicate Claims",
  NO_PREAUTHORIZATION = "Preauthorization Not Obtained",
  MEDICAL_NECESSITY = "Lack of Medical Necessity",
  CLAIM_NOT_SUBMITTED_ON_TIME = "Claim Not Submitted Timely",
  NETWORK = "Out-of-Network Provider",
  SITE_OF_CARE = "Not covered at site of care",
  COSMETIC_SERVICE_NOT_COVERED = "Service Not Covered (Cosmetic)",
  EXPERIMENTAL_SERVICE_NOT_COVERED = "Service Not Covered (Experimental)",
  INSURANCE_COVERAGE_TERMINATED = "Insurance Coverage Terminated",
}
